import axios, { AxiosError } from "axios";
import { APIError } from "@/backend/types/backendTypes";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { del } from "idb-keyval";
import { isPrivateMode } from "@lib/util-functions/checkPrivateMode";
import { getLocalStorage } from "@lib/util-functions/getLocalStorage";
import axiosInstance from "@lib/axios";
import { TRACKING_ERROR_MODAL_STORAGE_KEY_PREFIX } from "@components/Modals/TrackingParameterErrorModal";

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const token = getLocalStorage()?.getItem("token");

      if (!token) {
        throw new Error("No authentication token found");
      }

      try {
        const response = await axiosInstance.get(
          `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/account/logout`
        );

        getLocalStorage()?.removeItem("token");

        const ls = getLocalStorage();
        if (ls) {
          for (let i = ls.length - 1; i >= 0; i--) {
            const key = ls.key(i);
            if (key?.startsWith(TRACKING_ERROR_MODAL_STORAGE_KEY_PREFIX)) {
              ls.removeItem(key);
            }
          }
        }

        if (!(await isPrivateMode())) {
          await del("tracify_cache").catch(() => {});
        }

        await queryClient.invalidateQueries();
        return response.data;
      } catch (err) {
        if (axios.isAxiosError(err)) {
          const apiError = err.response?.data as APIError;
          throw new Error(apiError?.error ?? err.message);
        }
        throw err;
      }
    },
    onSuccess: () => {
      window.location.href = "/login";
    },
  });
};
